import { JsonObject, JsonProperty } from 'ta-json';
import { SubjectType } from '@src/app/generated/globalTypes';
import { GetDocumentationBySubjectType_documentationBySubjectType } from '@src/app/generated/GetDocumentationBySubjectType';
import { PropertyField } from '@src/app/model/property-field';
import { Id } from '@ess/jg-rule-executor';

/**
 * Documentation on a certain subject type (i.e. data types like Retailer and ModuleBlueprint)
 *
 * It contains some metadata on how to create a generic form for it and a comment to display to users when editing it.
 */
@JsonObject()
export class Documentation {
  @JsonProperty() id: Id<Documentation>;
  @JsonProperty() subjectType: SubjectType;
  @JsonProperty() fields: PropertyField[];
  @JsonProperty() comment: string | null;

  constructor(
    id: Id<Documentation>,
    subjectType: SubjectType,
    fields: PropertyField[],
    comment: string
  ) {
    this.id = id;
    this.subjectType = subjectType;
    this.fields = fields;
    this.comment = comment;
  }

  static fromGql(gql: GetDocumentationBySubjectType_documentationBySubjectType): Documentation {
    return new Documentation(
      gql.id,
      gql.subjectType,
      gql.fields.map(field => PropertyField.fromGql(field)),
      gql.comment
    );
  }
}
